import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrandProvider } from './brand/BrandProvider';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrandProvider>
        <App />
      </BrandProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
